import React from 'react';
import { useLocation } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb';
import DashboardOverview from '../components/DashboardOverview';
import User from '../components/settings/User';
import Role from '../components/settings/Role';
import { getPageContent } from '../utils/contentUtils';
import Product from '../components/product/Product';
import ProductGroup from '../components/product/ProductGroup';
import InventoryAdjustment from '../components/product/InventoryAdjustment';
import TransferOrder from '../components/product/TransferOrder';
import ProductCategories from '../components/product/ProductCategories';
import ProductUnits from '../components/product/ProductUnits';
import SupplierGroup from '../components/purchases/SupplierGroup';
import Suppliers from '../components/purchases/Suppliers';
import RecurringExpenses from '../components/purchases/RecurringExpenses';
import PurchaseOrders from '../components/purchases/PurchaseOrders';
import Bills from '../components/purchases/Bills';
import Expenses from '../components/purchases/Expenses';
import Currencies from '../components/settings/Currencies';
import Profile from '../components/settings/Profile';
import Branches from '../components/settings/Branches';
import DeliveryMethod from '../components/settings/DeliveryMethods';
import Taxes from '../components/settings/Taxes';
import Reason from '../components/settings/Reasons';
import Warhouses from '../components/settings/Warehouses';
import PaymentMethod from '../components/settings/PaymentMethods';
import PosPaymentModes from '../components/settings/PosPaymentModes';
import ProductConversionLinks from '../components/settings/ProductConversionLink';
import TransactionNumberSerie from '../components/settings/TransactionNumberSeries';
import WorkCenters from '../components/settings/WorkCenter';
import SalePerson from '../components/settings/SalesPersons';
import PaymentMode from '../components/settings/PaymentModes';
import Banking from '../components/banking/Banking';
import Reports from "../components/reports/Reports";
import ChartOfAccounts from "../components/accountant/ChartOfAccounts";
import BudgetOverview from "../components/budget/BudgetOverview";
import ManualJournal from "../components/accountant/ManualJournal";
import TransactionLocking from "../components/accountant/TransactionLocking";
import Customers from '../components/sales/customers';
import CustomerGroup from '../components/sales/CustomerGroup';
import SaleOrder from '../components/sales/SalesOrders';
import Invoices from '../components/sales/Invoices';
import PaymentReceive from '../components/sales/PaymentReceived';
import CreditNote from '../components/sales/CreditNotes';
import RetailSale from '../components/sales/RetailSales';
import PaymentMade from '../components/purchases/PaymentsMade';
import SupplierCredit from '../components/purchases/SupplierCredits';
import OpeningBalance from "../components/settings/OpeningBalance";
import AdvancedOptions from "../components/settings/AdvancedOptions";
import ConvertProduct from "../components/product/ConvertProduct";
import NewBusiness from "../components/new-business/NewBusiness";
import ProfitAndLoss from "../components/reports/business-overview/ProfitAndLoss";
import CashFlowStatement from "../components/reports/business-overview/CashFlowStatement";
import BalanceSheet from "../components/reports/business-overview/BalanceSheet";
import MovementOfEquity from "../components/reports/business-overview/MovementOfEquity";
import SalesByCustomer from "../components/reports/sales/SalesByCustomer";
import SalesByProduct from "../components/reports/sales/SalesByProduct";
import SalesBySalesPerson from "../components/reports/sales/SalesBySalesPerson";
import PosSalesByCustomer from "../components/reports/pos-sales/pos-sales-by-customer";
import PosSalesByProducts from "../components/reports/pos-sales/pos-sales-by-products";
import PurchaseBySupplier from "../components/reports/purchase-by-supplier/PurchaseBySupplier";
import PurchaseByProduct from "../components/reports/purchase-by-product/purchase-by-product";
import RefundHistory from "../components/reports/payments-received/RefundHistory";
import CreditNoteDetails from "../components/reports/payments-received/CreditNoteDetails";
import RefundHistorys from "../components/reports/payments-made/RefundHistory";
import SupplierCreditDetails from "../components/reports/payments-made/SupplierCreditDetails";
import RealizedGainLoss from "../components/reports/Currency/RealizedGainLoss";
import UnrealizedGainLoss from "../components/reports/Currency/UnrealizedGainLoss";
import ExpenseDetails from "../components/reports/Expense/ExpenseDetails";
import ExpenseByCategroy from "../components/reports/Expense/ExpenseByCategory";
import AccountTransactions from "../components/reports/accountant/AccountTransactions";
import AccountTypeSummary from "../components/reports/accountant/AccountTypeSummary";
import GeneralLedger from "../components/reports/accountant/GeneralLedger";
import DetailedGeneralLedger from "../components/reports/accountant/DetailedGeneralLedger";
import JournalReport from "../components/reports/accountant/JournalReport";
import TrialBalance from "../components/reports/accountant/TrialBalance";
import InventorySummary from "../components/reports/inventory/InventorySummary";
import StockSummaryReport from "../components/reports/inventory/StockSummaryReport";
import InventoryValutaionSummary from "../components/reports/inventory/InventoryValutaionSummary";
import ProductSalesReport from "../components/reports/inventory/ProductSalesReport";
import WarehouseReport from "../components/reports/inventory/WarehouseReport";
import InventoryAgingReport from "../components/reports/inventory/InventoryAgingReport";
import InventoryExpiryReport from "../components/reports/inventory/InventoryExpiryReport";
import ApAgingSummary from "../components/reports/payables/ApAgingSummary";
import ApAgingDetails from "../components/reports/payables/ApAgingDetails";
import BillsDetails from "../components/reports/payables/BillsDetails";
import SupplierBalanceDetails from "../components/reports/payables/SupplierBalaneDetails";
import SupplierBalanceSummary from "../components/reports/payables/SupplierBalanceSummary";
import PurchaseOrderDetails from "../components/reports/payables/PurchaseOrderDetails";
import PayableSummary from "../components/reports/payables/PayableSummary";
import PayableDetails from "../components/reports/payables/PayableDetails";
import ArGaingSummary from "../components/reports/receivables/ArGaingSummary";
import ArAgingDetails from "../components/reports/receivables/ArAgingDetails";
import InvoiceDetails from "../components/reports/receivables/InvoiceDetails";
import CustomerBalanceSummary from "../components/reports/receivables/CustomerBalaceSummary";
import CustomerBalanceDetails from "../components/reports/receivables/CustomerBalanceDetails";
import SalesOrderDetails from "../components/reports/receivables/SalesOrderDetails";
import ReceivableSummary from "../components/reports/receivables/ReceivableSummary";
import ReceivableDetails from "../components/reports/receivables/ReceivableDetails";


const DocumentationPage: React.FC = () => {
  const { pathname } = useLocation();

  // Special case for home overview - show dashboard
  if (pathname === '/home/overview') {
    return <DashboardOverview />;
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/advanced-options') {
    return <AdvancedOptions />;
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/users') {
    return <User />;
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/roles') {
    return <Role />;
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/currencies') {
    return <Currencies />;
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/profile') {
    return <Profile />;
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/branches') {
    return <Branches />;
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/taxes') {
    return <Taxes />;
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/DeliveryMethods') {
    return <DeliveryMethod />;
  }

   // Special case for users' settings - show user management
  if (pathname === '/settings/PosPaymentModes') {
    return <PosPaymentModes />;
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/ProductConversationLink') {
    return <ProductConversionLinks />;
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/TransactionNumberSeries') {
    return <TransactionNumberSerie />
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/PaymentModes') {
    return <PaymentMode />
  }


  // Special case for users' settings - show user management
  if (pathname === '/settings/WorkCenter') {
    return <WorkCenters />
  }

   // Special case for users' settings - show user management
  if (pathname === '/settings/SalesPersons') {
    return <SalePerson />
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/PaymentMethods') {
    return <PaymentMethod />;
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/warehouses') {
    return <Warhouses />;
  }

  // Special case for users' settings - show opening balance
  if (pathname === '/settings/opening-balances') {
    return <OpeningBalance />;
  }

  // Special case for users' settings - show user management
  if (pathname === '/settings/reasons') {
    return <Reason />;
  }

  // Special case for products - show product management
  if (pathname === '/products/products') {
    return <Product />;
  }

  // Special case for products - show product management
  if (pathname === '/products/product-groups') {
    return <ProductGroup />;
  }

  // Special case for products - show product management
  if (pathname === '/products/inventory-adjustments') {
    return <InventoryAdjustment />;
  }

  // Special case for products - show transfer order management
  if (pathname === '/products/transfer-orders') {
    return <TransferOrder />;
  }

  // Special case for products - show product categories management
  if (pathname === '/products/product-categories') {
    return <ProductCategories />;
  }

  // Special case for products - show product units management
  if (pathname === '/products/product-units') {
    return <ProductUnits />;
  }

  // Special case for products - show product units management
  if (pathname === '/products/convert-product') {
    return <ConvertProduct />;
  }

  // Special case for purchases - show supplier group management
  if (pathname === '/purchases/supplier-group') {
    return <SupplierGroup />;
  }

  // Special case for purchases - show suppliers management
  if (pathname === '/purchases/suppliers') {
    return <Suppliers />;
  }

  // Special case for purchases - show recurring expenses management
  if (pathname === '/purchases/recurring-expenses') {
    return <RecurringExpenses />;
  }

  // Special case for purchases - show purchase orders management
  if (pathname === '/purchases/purchase-orders') {
    return <PurchaseOrders />;
  }

  // Special case for purchases - show bills management
  if (pathname === '/purchases/bills') {
    return <Bills />;
  }

  // Special case for purchases - show expenses management
  if (pathname === '/purchases/expenses') {
    return <Expenses />;
  }

  // Special case for purchases - show expenses management
  if (pathname === '/purchases/payments-made') {
    return <PaymentMade />;
  }

  // Special case for purchases - show expenses management
  if (pathname === '/purchases/supplier-credits') {
    return <SupplierCredit />;
  }

  // Special case for Sales - show expenses management
  if (pathname === '/sales/customers') {
    return <Customers />;
  }

  // Special case for Sales - show expenses management
  if (pathname === '/sales/customer-group') {
    return <CustomerGroup />;
  }

  // Special case for Sales - show expenses management
  if (pathname === '/sales/sales-orders') {
    return <SaleOrder />;
  }

  // Special case for Sales - show expenses management
  if (pathname === '/sales/invoices') {
    return <Invoices />;
  }

  // Special case for Sales - show expenses management
  if (pathname === '/sales/payments-received') {
    return <PaymentReceive />;
  }

  // Special case for Sales - show expenses management
  if (pathname === '/sales/credit-notes') {
    return <CreditNote />;
  }

  // Special case for Sales - show expenses management
  if (pathname === '/sales/retail-sales') {
    return <RetailSale />;
  }

  // Special case for banking - show banking management
  if (pathname === '/banking') {
    return <Banking />;
  }

  // Special case for reports - show reports
  if (pathname === '/reports/overview') {
    return <Reports />;
  }

  // Special case for reports - show report - profit and loss
  if (pathname === '/reports/business-overview/profit-and-loss') {
    return <ProfitAndLoss />;
  }

  // Special case for reports - show report - cash flow statement
  if (pathname === '/reports/business-overview/cash-flow-statement') {
    return <CashFlowStatement />;
  }

  // Special case for reports - show report - cash Balance Sheet
  if (pathname === '/reports/business-overview/balance-sheet') {
    return <BalanceSheet />;
  }

  // Special case for reports - show report - cash Movement of Equity
  if (pathname === '/reports/business-overview/movement-of-equity') {
    return <MovementOfEquity />;
  }

  // Special case for reports - show report - cash sales by customer
  if (pathname === '/reports/sales/sales-by-customer') {
    return <SalesByCustomer />;
  }

  // Special case for reports - show report - cash sales by product
  if (pathname === '/reports/sales/sales-by-product') {
    return <SalesByProduct />;
  }

  // Special case for reports - show report - cash sales by sales person
  if (pathname === '/reports/sales/sales-by-sales-person') {
    return <SalesBySalesPerson />;
  }

  // Special case for reports - show report - cash pos sales by customer
  if (pathname === '/reports/pos-sales/pos-sales-by-customer') {
    return <PosSalesByCustomer />;
  }


  // Special case for reports - show report - cash sales by product
  if (pathname === '/reports/pos-sales/pos-sales-by-products') {
    return <PosSalesByProducts />;
  }

  // Special case for reports - show report - cash purchase by supplier
  if (pathname === '/reports/purchase/purchase-by-supplier') {
    return <PurchaseBySupplier />;
  }

  // Special case for reports - show report - cash purchase by supplier
  if (pathname === '/reports/purchase/purchase-by-product') {
    return <PurchaseByProduct />;
  }

  // Special case for reports - show report - cash purchase by supplier
  if (pathname === '/reports/payments-received/payments-received') {
    return <PaymentReceive />;
  }

  // Special case for reports - show report - cash purchase by supplier
  if (pathname === '/reports/payments-received/refund-history') {
    return <RefundHistory />;
  }

  // Special case for reports - show report - cash purchase by supplier
  if (pathname === '/reports/payments-received/credit-note-details') {
    return <CreditNoteDetails />;
  }

  // Special case for reports - show report - cash purchase by supplier
  if (pathname === '/reports/payments-made/payments-made') {
    return <PaymentMade />;
  }

  // Special case for reports - show report - cash purchase by supplier
  if (pathname === '/reports/payments-made/refund-history') {
    return <RefundHistorys />;
  }

  // Special case for reports - show report - cash purchase by supplier
  if (pathname === '/reports/payments-made/supplier-credit-details') {
    return <SupplierCreditDetails />;
  }

  // Special case for reports - show report - cash purchase by supplier
  if (pathname === '/reports/currency/realized-gain-or-loss') {
    return <RealizedGainLoss />;
  }

  // Special case for reports - show report - cash purchase by supplier
  if (pathname === '/reports/currency/unrealized-gain-or-loss') {
    return <UnrealizedGainLoss />;
  }


  // Special case for reports - show report - cash purchase by supplier
  if (pathname === '/reports/purchase/expense-details') {
    return <ExpenseDetails />;
  }

  // Special case for reports - show report - cash purchase by supplier
  if (pathname === '/reports/purchase/expense-by-category') {
    return <ExpenseByCategroy />;
  }

  // report accountant

  // Special case for reports - show report
  if (pathname === '/reports/accountant/account-transactions') {
    return <AccountTransactions />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/accountant/account-type-summary') {
    return <AccountTypeSummary />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/accountant/general-ledger') {
    return <GeneralLedger />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/accountant/detailed-general-ledger') {
    return <DetailedGeneralLedger />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/accountant/journal-report') {
    return <JournalReport />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/accountant/trial-balance') {
    return <TrialBalance />;
  }

  // inventory

  // Special case for reports - show report
  if (pathname === '/reports/inventory/inventory-summary') {
    return <InventorySummary />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/inventory/stock-summary-report') {
    return <StockSummaryReport />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/inventory/inventory-valuation-summary') {
    return <InventoryValutaionSummary />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/inventory/product-sales-report') {
    return <ProductSalesReport />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/inventory/warehouse-report') {
    return <WarehouseReport />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/inventory/inventory-aging-report') {
    return <InventoryAgingReport />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/inventory/inventory-expiry-report') {
    return <InventoryExpiryReport />;
  }

  // payable

  // Special case for reports - show report
  if (pathname === '/reports/payables/ap-aging-summary') {
    return <ApAgingSummary />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/payables/ap-aging-details') {
    return <ApAgingDetails />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/payables/bills-details') {
    return <BillsDetails />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/payables/supplier-balance-details') {
    return <SupplierBalanceDetails />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/payables/supplier-balance-summary') {
    return <SupplierBalanceSummary />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/payables/purchase-order-details') {
    return <PurchaseOrderDetails />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/payables/payable-summary') {
    return <PayableSummary />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/payables/payable-details') {
    return <PayableDetails />;
  }


  // receivables

  // Special case for reports - show report
  if (pathname === '/reports/receivables/ar-aging-summary') {
    return <ArGaingSummary />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/receivables/ar-aging-details') {
    return <ArAgingDetails />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/receivables/invoice-details') {
    return <InvoiceDetails />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/receivables/customer-balance-summary') {
    return <CustomerBalanceSummary />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/receivables/customer-balance-details') {
    return <CustomerBalanceDetails />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/receivables/sales-order-details') {
    return <SalesOrderDetails />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/receivables/receivable-summary') {
    return <ReceivableSummary />;
  }

  // Special case for reports - show report
  if (pathname === '/reports/receivables/receivable-details') {
    return <ReceivableDetails />;
  }


  // Special case for Accountant - show chart of accounts
  if (pathname === '/accountant/chart-of-accounts') {
    return <ChartOfAccounts />;
  }

  // Special case for Accountant - show manual journals
  if (pathname === '/accountant/manual-journals') {
    return <ManualJournal />;
  }

  // Special case for Accountant - show transaction locking
  if (pathname === '/accountant/transaction-locking') {
    return <TransactionLocking />;
  }

  // Special case for Budget
  if (pathname === '/budget') {
    return <BudgetOverview />;
  }

  // Special case for New Business
  if (pathname === '/new-business-setup') {
    return <NewBusiness />;
  }


  const content = getPageContent(pathname);

  if (!content) {
    return (
      <div className="content-card">
        <div className="text-center py-12">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Page Not Found</h1>
          <p className="text-gray-600 mb-6">
            The page you're looking for doesn't exist or hasn't been created yet.
          </p>
          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-gray-900">Available Content</h2>
            <p className="text-gray-600">
              This is a demo application. In a real implementation, you would have:
            </p>
            <ul className="text-left max-w-md mx-auto space-y-2 text-gray-600">
              <li>• Comprehensive documentation for each section</li>
              <li>• Step-by-step guides and tutorials</li>
              <li>• Video content and screenshots</li>
              <li>• Interactive examples and demos</li>
              <li>• Search functionality across all content</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <Breadcrumb pathname={pathname} />

      <div className="content-card">
        <div className="prose max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">{content.title}</h1>

          {content.lastUpdated && (
            <p className="text-sm text-gray-500 mb-6">
              Last updated: {content.lastUpdated}
            </p>
          )}

          <div className="text-gray-700 leading-relaxed mb-8 prose prose-blue max-w-none">
            <div dangerouslySetInnerHTML={{ __html: content.content }} />
          </div>

          {content.sections && content.sections.length > 0 && (
            <div className="space-y-8">
              {content.sections.map((section) => (
                <div key={section.id} id={section.id} className="scroll-mt-20">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">{section.title}</h2>
                  <div className="text-gray-700 leading-relaxed mb-6 prose prose-blue max-w-none">
                    <div dangerouslySetInnerHTML={{ __html: section.content }} />
                  </div>

                  {section.subsections && section.subsections.length > 0 && (
                    <div className="space-y-6">
                      {section.subsections.map((subsection) => (
                        <div key={subsection.id} id={subsection.id} className="scroll-mt-20">
                          <h3 className="text-xl font-medium text-gray-900 mb-3">{subsection.title}</h3>
                          <div className="text-gray-700 leading-relaxed prose prose-blue max-w-none">
                            <div dangerouslySetInnerHTML={{ __html: subsection.content }} />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Table of Contents */}
      {content.sections && content.sections.length > 0 && (
        <div className="content-card">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Table of Contents</h3>
          <nav className="space-y-2">
            {content.sections.map((section) => (
              <div key={section.id}>
                <a
                  href={`#${section.id}`}
                  className="block text-primary-600 hover:text-primary-700 font-medium"
                >
                  {section.title}
                </a>
                {section.subsections && section.subsections.length > 0 && (
                  <div className="ml-4 mt-2 space-y-1">
                    {section.subsections.map((subsection) => (
                      <a
                        key={subsection.id}
                        href={`#${subsection.id}`}
                        className="block text-gray-600 hover:text-gray-800 text-sm"
                      >
                        {subsection.title}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>
        </div>
      )}
    </div>
  );
};

export default DocumentationPage;
